import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const GeneralNavMenuActionsContext = createContext(null);

export function GeneralNavMenuProvider({ children }) {
  const [pageActions, setPageActions] = useState(null);

  const registerPageActions = useCallback((actions) => {
    setPageActions(actions || null);
  }, []);

  const value = useMemo(
    () => ({ pageActions, registerPageActions }),
    [pageActions, registerPageActions]
  );

  return (
    <GeneralNavMenuActionsContext.Provider value={value}>
      {children}
    </GeneralNavMenuActionsContext.Provider>
  );
}

/**
 * Lets a page override + menu actions (e.g. open in-page dialogs).
 * Falls back to route navigation when no handler is registered.
 */
export function useGeneralNavMenuPageActions({ onNewEvent, onNewHour, onNewAbsence } = {}) {
  const registerPageActions = useContext(GeneralNavMenuActionsContext)?.registerPageActions;

  useEffect(() => {
    if (!registerPageActions) return undefined;
    if (!onNewEvent && !onNewHour && !onNewAbsence) {
      registerPageActions(null);
      return () => registerPageActions(null);
    }
    registerPageActions({ onNewEvent, onNewHour, onNewAbsence });
    return () => registerPageActions(null);
  }, [registerPageActions, onNewEvent, onNewHour, onNewAbsence]);
}

export function useGeneralNavMenuPageActionsState() {
  return useContext(GeneralNavMenuActionsContext)?.pageActions || null;
}
